export interface ClassSelection {
    selectedClassId: string | null;
    secondClassId: string | null;
}

export interface AllUserSelections {
    [taskId: string]: ClassSelection[];
}

export const mapSelectionsToClassIds = (eventTasks: any[]): AllUserSelections => {
    return eventTasks?.reduce((acc, currentTask) => {
        if (currentTask.Participant_Choices__r?.records) {
            // Map the selections to only include class IDs
            const classIds = currentTask.Participant_Choices__r.records.map((record: any) => {
                const selectedOption = record.Selected_Option__c;
                const secondOption = record.Second_Option__c;

                // Find the class ID for the selected option
                let selectedClassId = null;
                let secondClassId = null;

                if (currentTask.Blocks__r?.records) {
                    if (currentTask.Type__c === "Track Selection") {
                        const selectedBlock = currentTask.Blocks__r.records.find((block: any) =>
                            block.Name === selectedOption || block.Name === secondOption
                        );
                        selectedClassId = selectedBlock?.Id;
                    }
                    else {
                        for (const block of currentTask.Blocks__r.records) {
                            if (block.Classes__r) {
                                const selectedClass = block.Classes__r.find((cls: any) =>
                                    cls.HN_Session_title__c === selectedOption
                                );
                                if (selectedClass) {
                                    selectedClassId = selectedClass.Id;
                                }

                                const secondClass = block.Classes__r.find((cls: any) =>
                                    cls.HN_Session_title__c === secondOption
                                );
                                if (secondClass) {
                                    secondClassId = secondClass.Id;
                                }
                            }
                        }
                    }
                }

                return {
                    selectedClassId,
                    secondClassId
                };
            });

            acc[currentTask.Id] = classIds;
        }
        return acc;
    }, {} as AllUserSelections) || {};
};
